/**
 * Landing page — 14 sections, driven by admin CMS (with hardcoded defaults).
 * Header / Footer / FAQ are untouched.
 */
import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FAQSection from '../components/FAQSection';
import SEO, {
  orgSchema, websiteSchema, productSchema, howToSchema, breadcrumbSchema,
} from '../components/SEO';
import {
  useLandingContent, useTestimonialsAggregate,
  HeroV2, BreakerV2, PainPointsV2, ProblemIdentificationV2,
  Proof1V2, Proof2V2, CtaBlockV2, SneakPeekV2, PromiseV2, TestimonialsV2,
} from '../components/landing_v2/LandingSections';

const QuizLanding = () => {
  const content = useLandingContent();
  const c = content || {};
  const agg = useTestimonialsAggregate();

  const seo = c.seo || {};
  const jsonLd = [
    orgSchema(),
    websiteSchema(),
    productSchema({ ratingValue: agg.avg, ratingCount: agg.count }),
    howToSchema(),
    breadcrumbSchema([{ name: 'Home', path: '/' }]),
  ];

  return (
    <div className="min-h-screen flex flex-col bg-white dark:bg-black transition-colors duration-200">
      <SEO
        title={seo.title}
        description={seo.description}
        keywords={seo.keywords}
        image={seo.og_image}
        path="/"
        jsonLd={jsonLd}
      />
      <Header />
      <main className="flex-1">
        <HeroV2 data={c.hero} />
        <BreakerV2 data={c.breaker} />
        <PainPointsV2 data={c.pain_points} />
        <ProblemIdentificationV2 data={c.problem_identification} />
        <Proof1V2 data={c.proof_1} />
        <Proof2V2 data={c.proof_2} />
        <CtaBlockV2 data={c.cta_mid_1} testId="cta-mid-1-btn" compact />
        <SneakPeekV2 data={c.sneak_peek} />
        <PromiseV2 data={c.promise} />
        <CtaBlockV2 data={c.cta_mid_2} testId="cta-mid-2-btn" compact />
        <TestimonialsV2 />
        <FAQSection />
        <CtaBlockV2 data={c.cta_final} testId="cta-final-btn" />
      </main>
      <Footer />
    </div>
  );
};

export default QuizLanding;
